import ArrowBackLight from "@assets/navigation/back.svg";
import LightCustomButton from "@components/buttons/LightCustomButton";
import TabSwitcherWeb from "@components/switcher/TabSwitcherWeb";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import BankCompanyOwned from "./BankCompanyOwned";
import BankInvoiceUsers from "./BankInvoiceUsers";
import BankManagementSlider from "./components/BankManagementSlider";

const BankManagement = () => {
  const navigate = useNavigate();
  const [addBankSliderOpen, setAddBankSliderOpen] = useState<boolean>(false);

  const tabs = [
    {
      label: "Company Owned",
      component: (
        <BankCompanyOwned
          key="company-owned"
          addBankSliderOpen={addBankSliderOpen}
          setAddBankSliderOpen={setAddBankSliderOpen}
        />
      ),
    },
    {
      label: "Invoice Users Banks",
      component: <BankInvoiceUsers key="invoice-users" />,
    },
  ];

  return (
    <div className="flex flex-col h-full">
      <div className="h-[70px] border-b border-border-subtle bg-bg-page-body flex flex-row sticky top-0 bg-white z-10 pl-[20px] w-full">
        <div className="flex flex-grow justify-between items-center w-full mr-4">
          <div className="flex gap-2 items-center">
            <img
              src={ArrowBackLight}
              alt="Back"
              className="cursor-pointer"
              onClick={() => navigate("/invoice-approvals")}
            />
            <p className="flex text-text-base text-[14px] font-semibold items-center">
              Bank Management
            </p>
          </div>
          <LightCustomButton
            text="+ ADD BANK"
            isActive={true}
            onClick={() => setAddBankSliderOpen(true)}
          />
        </div>
      </div>
      <div className="flex-1 overflow-hidden mt-4 mx-4">
        <TabSwitcherWeb tabs={tabs} full={true} />
      </div>
      <BankManagementSlider
        isOpen={addBankSliderOpen}
        onClose={() => setAddBankSliderOpen(false)}
      />
    </div>
  );
};

export default BankManagement;
